import React, { Fragment } from 'react';
import { arrayOf, bool, func, string } from 'prop-types';
import Spinner from '@johnlewispartnership/wtr-ingredients/ingredients/Spinner';
import AddressFormModalRouted from 'components/Address/common/AddressFormModalRouted';
import AddAddressButtonModal from 'components/Address/common/AddAddressButtonModal';
import classNames from 'classnames';
import styles from './AddAddressModal.scss';

const addAddressModalDefaultPropValidate = [];

const AddAddressModal = ({
  addAddressTitle = 'Add Address',
  buttonMessage = 'Add an address',
  loading = false,
  manualOnly = true,
  onAfterSubmit,
  roundedAddress = false,
  showAsLink,
  showAsPlaceholder,
  submitText = 'Save',
  ukOnlyAddress,
  validate = addAddressModalDefaultPropValidate,
}) => (
  <Fragment>
    {loading ? (
      <div
        className={classNames(styles.wrapper, {
          [styles.roundedAddress]: roundedAddress,
        })}
      >
        <div className={styles.spinnerOverlay}>
          <Spinner />
        </div>
        <AddAddressButtonModal
          showAsLink={showAsLink}
          showAsPlaceholder={showAsPlaceholder}
          validate={validate}
          buttonMessage={buttonMessage}
        />
      </div>
    ) : (
      <div
        className={classNames({
          [styles.roundedAddress]: roundedAddress,
        })}
      >
        <AddAddressButtonModal
          showAsLink={showAsLink}
          showAsPlaceholder={showAsPlaceholder}
          validate={validate}
          buttonMessage={buttonMessage}
        />
      </div>
    )}
    <AddressFormModalRouted
      ukOnlyAddress={ukOnlyAddress}
      onAfterSubmit={onAfterSubmit}
      addAddressTitle={addAddressTitle}
      submitText={submitText}
      manualOnly={manualOnly}
    />
  </Fragment>
);

AddAddressModal.propTypes = {
  addAddressTitle: string,
  buttonMessage: string,
  loading: bool,
  manualOnly: bool,
  onAfterSubmit: func.isRequired,
  roundedAddress: bool,
  showAsLink: bool.isRequired,
  showAsPlaceholder: bool.isRequired,
  submitText: string,
  ukOnlyAddress: bool.isRequired,
  validate: arrayOf(func),
};

export default AddAddressModal;
